/**
 * Api call instance using javascript fetch
 */

const get = ({ url, token, timeout = 10000 }) => {
    const options = {
        method: 'GET',
        timeout,
        headers: {
            ...(token && { Authorization: `bearer ${token}` }),
        },
    };
    return fetch(url, options)
        .then(async (resp) => {
            const { status } = resp;
            const data = await resp.json();
            return { data, status };
        }).catch(err => ({ err }));
};

const post = ({
    url, token, body = {}, timeout = 10000,
}) => {
    const options = {
        method: 'POST',
        timeout,
        body: JSON.stringify(body),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...(token && { Authorization: `bearer ${token}` }),
        },
    };
    return fetch(url, options)
        .then(async (resp) => {
            if (!resp.ok) {
                throw new Error(resp.status);
            }
            const { status } = resp;
            const data = await resp.json();
            return { data, status };
        });
};

export default {
    get, post,
};
